import weddingCeremonyImage from '../assets/images/Wedding Ceremony.jpg';
import preWeddingImage from '../assets/images/Prewedding.jpg';
import engagementCeremonyImage from '../assets/images/Engagement Ceremony.jpg';
import haldiImage from '../assets/images/Haldi.jpg';
import mehendiImage from '../assets/images/mehindi.jpg';
import receptionPartyImage from '../assets/images/Reception party.jpg';
import traditionalImage from '../assets/images/Traditional.jpg';
import couplePortraitImage from '../assets/images/Couple Portrait.jpg';

const portfolioData = [
  {
    id: 1,
    image: weddingCeremonyImage,
    category: "wedding",
    title: "Wedding Ceremony"
  },
  {
    id: 2,
    image: preWeddingImage,
    category: "pre-wedding",
    title: "Pre-Wedding Shoot"
  },
  {
    id: 3,
    image: engagementCeremonyImage,
    category: "engagement",
    title: "Engagement Ceremony"
  },
  {
    id: 4,
    image: haldiImage,
    category: "haldi",
    title: "Haldi Ceremony"
  },
  {
    id: 5,
    image: mehendiImage,
    category: "mehendi",
    title: "Mehendi Ceremony"
  },
  {
    id: 6,
    image: receptionPartyImage,
    category: "reception",
    title: "Reception Party"
  },
  {
    id: 7,
    image: traditionalImage,
    category: "wedding",
    title: "Traditional Wedding"
  },
  {
    id: 8,
    image: couplePortraitImage,
    category: "pre-wedding",
    title: "Couple Portrait"
  }
];

export default portfolioData;
